module.exports = __webpack_public_path__ + "img/logo_w.6f4fe492.png";